import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { Check, Upload } from "lucide-react";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";

const Vendordetails = ({ vendorList, selectedRow, issueDetails }) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const [form, setForm] = useState({});
  const [seletedVendor, setSelectedVendor] = useState(null);

  const addVendorDetails = [
    {
      label: "Name",
      value: "name",
      type: "text",
      disabled: true,
    },
    {
      label: "Contact Person",
      value: "contactperson",
      type: "text",
      disabled: true,
    },
    {
      label: "Contact Email",
      value: "contactemail",
      type: "text",
      disabled: true,
    },
    {
      label: "Contact Mobile",
      value: "contactmobile",
      type: "text",
      disabled: true,
    },
    {
      label: "Address",
      value: "address",
      type: "text",
      disabled: true,
    },
  ];

  const handleChange = async (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const tagVendorToIssue = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/vehicleissues`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          id: selectedRow?.id,
          vendorId: seletedVendor?.id,
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.success("Vendor Updated successfully");
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle details:", error);
    }
  };

  useEffect(() => {
    if (issueDetails?.vendorId) {
      const vendor = vendorList.find((v) => v.id === issueDetails?.vendorId);
      setForm({
        name: vendor?.name || "",
        contactperson: vendor?.contactPerson || "",
        contactemail: vendor?.contactEmail || "",
        contactmobile: vendor?.contactMobile || "",
        address: vendor?.address || "",
      });
    }
  }, [issueDetails?.vendorId]);

  return (
    <>
      <FormControl fullWidth size="small">
        <InputLabel>Vendor Details</InputLabel>

        <Select
          value={seletedVendor}
          onChange={(e) => {
            const vendor = vendorList.find((v) => v.id === e.target.value);

            setSelectedVendor(vendor);

            setForm({
              name: vendor?.name || "",
              contactperson: vendor?.contactPerson || "",
              contactemail: vendor?.contactEmail || "",
              contactmobile: vendor?.contactMobile || "",
              address: vendor?.address || "",
            });
          }}
        >
          {vendorList?.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              {option.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <div className="bg-gray-200 p-4 mt-6">
        <div className="flex-1">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {addVendorDetails.map((field, index) => (
              <div key={index} className="group">
                <label className="block mb-2 font-semibold text-gray-700 text-sm">
                  {field.label}
                  {field.required && (
                    <span className="text-red-500 ml-1">*</span>
                  )}
                </label>

                {field.type === "dropdown" ? (
                  <FormControl
                    fullWidth
                    size="small"
                    className="transition-all duration-200 hover:shadow-md"
                  >
                    <InputLabel id={`drop-label-${index}`}>
                      {field?.label}
                    </InputLabel>
                    <Select
                      labelId={`drop-label-${index}`}
                      value={form[field.value] || ""}
                      onChange={(e) => setSelectedVendor(e.target.value)}
                      label={field?.label}
                      sx={{
                        borderRadius: "8px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#e5e7eb",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#818cf8",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#6366f1",
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 240,
                            borderRadius: "8px",
                            boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
                          },
                        },
                      }}
                    >
                      {field?.subCategory
                        ?.filter((opt) => opt.item !== "inverted") // optional safety
                        .map((option, idx) => (
                          <MenuItem
                            key={idx}
                            value={option.key ?? option.label ?? option.value}
                          >
                            {option.value}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                ) : field.type === "file" ? (
                  <div className="space-y-3">
                    <div className="relative">
                      <input
                        disabled={field.disabled}
                        type="file"
                        id={`file-${index}`}
                        multiple
                        onChange={(e) =>
                          handleChange(field.value, e.target.files)
                        }
                        className="hidden"
                        accept="image/*"
                      />
                      <label
                        htmlFor={`file-${index}`}
                        className={`flex items-center justify-center gap-2 w-full border-2 border-dashed rounded-lg p-4 transition-all duration-200 ${
                          field.disabled
                            ? "bg-gray-100 cursor-not-allowed"
                            : "border-indigo-300 hover:border-indigo-500 hover:bg-indigo-50 cursor-pointer"
                        }`}
                      >
                        <Upload size={20} className="text-indigo-600" />
                        <span className="text-sm text-gray-600">
                          {form[field.value] ? "Change file" : "Upload file"}
                        </span>
                      </label>
                    </div>
                    {form[field.value] && (
                      <div className="relative rounded-lg overflow-hidden shadow-md border-2 border-gray-200">
                        <img
                          src={
                            form[field.value].Location ||
                            form[field.value].path ||
                            form[field.value].url
                          }
                          className="w-full h-32 object-cover"
                          alt="Preview"
                        />
                        <div className="absolute top-2 right-2 bg-green-500 text-white p-1 rounded-full">
                          <Check size={16} />
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <input
                    disabled={field.disabled}
                    type={field.type}
                    value={form[field.value] || ""}
                    onChange={(e) => handleChange(field.value, e.target.value)}
                    className={`w-full border rounded-lg px-4 py-2.5 text-sm transition-all duration-200 ${
                      field.disabled
                        ? "bg-gray-100 cursor-not-allowed"
                        : "border-gray-300 hover:border-indigo-400 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200"
                    } outline-none`}
                    placeholder={`Enter ${field.label.toLowerCase()}`}
                  />
                )}
              </div>
            ))}
          </div>

          {!issueDetails?.vendorId && <div className="flex justify-center mt-8">
            <Button
              sx={{
                bgcolor: "#0c4bc0ff",
                fontWeight: 500,
                px: 2,
                color: "white",
                borderRadius: 1,
                width: "200px",
                cursor: "pointer",
                "&:hover": {
                  bgcolor: "#083a9a",
                },
              }}
              onClick={() => {
                tagVendorToIssue();
              }}
            >
              Tag Vendor To Issue
            </Button>
          </div>}
        </div>
      </div>
    </>
  );
};

export default Vendordetails;
